import React from "react";
import { TextArea as NovusTextArea } from "@arcadis/novus-design-system";
import { inputStyles } from "../variants";

export const TextArea: React.FC<React.ComponentProps<typeof NovusTextArea>> = (props) => {
    return (
        <>
            <NovusTextArea {...props} {...inputStyles} />
        </>
    );
};
